'use client';

import { Children, cloneElement } from 'react';

import { usePopperContext } from './hooks';

import type { FC, ReactElement } from 'react';

export interface IsOpenProps {
  children: ReactElement | ReactElement[];
}

export const PopperIsOpen: FC<IsOpenProps> = ({ children, ...props }) => {
  const { isOpen } = usePopperContext();

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, {
          isOpen,
          ...props,
        } ) )}
    </>
  );
};
